<template>
  <Flex
    direction="column"
    :gap="0.5"
  >
    <BaseTask
      :heading="!hasActiveVenue ? $t('treatwell.description') : $t('treatwell.description_completed')"
      :text="updated.description ? $t('admin.treatwell.main.task_pending') : ''"
      :state="
        !enableSection
          ? 'blocked'
          : descriptionDone
          ? 'completed'
          : undefined
      "
      :buttonIcon="updated.description ? 'clock' : enableSection ? 'edit' : undefined"
      @click="
        router.push({ name: 'treatwell-salon-description' })
      "
      @buttonClick="
        router.push({ name: 'treatwell-salon-description' })
      "
      v-test="'description-todo-item'"
      v-intercom="'mp-dashboard-task-description'"
    />
    <BaseTask
      v-if="showPhotosTask()"
      :heading="
        photosDone
          ? $t(
              'admin.treatwell.main.getting_paid.salon_photos_provided'
            )
          : !treatwellVenue?.images?.length
          ? $t(
              'admin.treatwell.main.getting_paid.provide_salon_photos'
            )
          : $t(
              'admin.treatwell.main.getting_paid.providing_salon_photos',
              { count: treatwellVenue?.images?.length }
            )
      "
      :text="updated.photos ? $t('admin.treatwell.main.task_pending') : ''"
      :state="
        !enableSection || !treatwellVenue
          ? 'blocked'
          : photosDone
          ? 'completed'
          : undefined
      "
      :buttonIcon="
      updated.photos ? 'clock' :
        !enableSection || !treatwellVenue
          ? undefined
          : photosDone
          ? 'edit'
          : 'upload'
      "
      @click="router.push({ name: 'treatwell-salon-photos' })"
      @buttonClick="
        router.push({ name: 'treatwell-salon-photos' })
      "
      v-test="'company-photos-todo-item'"
      v-intercom="'mp-dashboard-task-company-photos'"
    />
    <BaseTask
      :heading="
        $t('admin.treatwell.main.getting_seen.set_roster')
      "
      :text="updated.roster ? $t('admin.treatwell.main.task_pending') : ''"
      :state="enableSection ? 'completed' : 'blocked'"
      :buttonIcon="updated.roster ? 'clock' : enableSection ? 'edit' : undefined"
      @click="router.push({ name: 'treatwell-set-roster' })"
      @buttonClick="router.push({ name: 'treatwell-set-roster' })"
      v-test="'roster-todo-item'"
      v-intercom="'mp-dashboard-task-roster'"
    />
    <BaseTask
      :heading="
        $t('admin.treatwell.main.getting_seen.employee_availability')
      "
      :text="updated.employeeAvailability ? $t('admin.treatwell.main.task_pending') : ''"
      :state="enableSection && hasActiveVenue ? 'completed' : 'blocked'"
      :buttonIcon="
        updated.employeeAvailability
          ? 'clock'
          : enableSection && hasActiveVenue
          ? 'edit'
          : undefined
      "
      @click="router.push({ name: 'treatwell-employee-availability' })"
      @buttonClick="
        router.push({ name: 'treatwell-employee-availability' })
      "
      v-test="'employee-availability-todo-item'"
      v-intercom="'mp-dashboard-task-employee-availability'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useTreatwellStore } from '@/stores/treatwell';
import type { TreatwellVenue } from '@/types';
import type { UpdatedTasks } from '../dashboard/types';
import { useProfileTasks } from './use-profile-tasks';

// What the salon's page on the marketplace shows: description, photos, opening hours and team
const props = defineProps<{
  treatwellVenue: Partial<TreatwellVenue> | null;
  enableSection: boolean;
  // Saved but not on the marketplace yet (see ModuleBase's event in index.vue)
  updated: UpdatedTasks;
}>();

const router = useRouter();
const { hasActiveVenue } = storeToRefs(useTreatwellStore());
const { descriptionDone, showPhotosTask, photosDone } = useProfileTasks(
  () => props.treatwellVenue,
);
</script>
